import { makeStyles, Theme, } from '@material-ui/core/styles';

export const makeCookiesPolityListStyles = makeStyles((theme: Theme) => ({
    list: {
        listStyleType: 'decimal',
    },

    subList: {
        listStyleType: 'lower-alpha',
    },

    listItem: {
        marginBottom: theme.spacing(2),
    },
}));
